// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"462":"2bc13253","897":"e986ac46"}[chunkId] + ".css";
};